import { css } from 'aphrodite';
import React, { ReactNode } from 'react';
import { FormFieldType, IFormField } from '../../../../../../extViewmodels';
import { Checkbox } from '../../../../../components/Checkbox';
import { ISelectBoxOption, SelectBox } from '../../../../../components/SelectBox';
import { TextInput } from '../../../../../components/TextInput';
import { baseStyleSheet } from '../../../../../styles/styles';
import { styleSheet } from '../../styles';

interface PreviewCustomFormFieldsProps {
	customFormFields: IFormField<string>[];
}

export const PreviewCustomFormFields: React.FC<PreviewCustomFormFieldsProps> = ({ customFormFields }) => {
	const getFieldOptions = React.useCallback((f: IFormField<string>) => {
		const fieldDropdownOptions = f.options?.map(o => {
			return {
				id: o.id || '',
				title: o.label,
				value: o.label,
			};
		});
		const onSelectionChanged = (_selectedOption: ISelectBoxOption<string>) => {
			// No-op for preview
		};
		const onRenderTriggerTitle = (selectedOption: ISelectBoxOption<string>) => {
			return <span>{selectedOption.title as ReactNode}</span>;
		};
		return (
			<SelectBox
				options={fieldDropdownOptions}
				onRenderSelectedOptionTitle={onRenderTriggerTitle}
				onSelectionChanged={onSelectionChanged}
				placeholder={<span>Select option</span>}
				triggerClassName={css(styleSheet.selectBoxtriggerButton)}
				selectedOption={fieldDropdownOptions?.find((x: { id: string }) => x.id === f.value) || undefined}
			/>
		);
	}, []);

	const getMultipleOptions = React.useCallback((f: IFormField<string>) => {
		const fieldCheckboxOptions = f.options?.map(o => {
			const fieldCheckboxSelectedOptions: string[] = f.value?.split(',') ?? [];

			return (
				<Checkbox
					key={o.id}
					id={o.id}
					className={css(styleSheet.checkbox)}
					checked={fieldCheckboxSelectedOptions?.includes(o.id)}
					readOnly
				>
					<span>{o.label}</span>
				</Checkbox>
			);
		});
		return <>{fieldCheckboxOptions}</>;
	}, []);

	return (
		<div data-testid='basic-form-fields'>
			{customFormFields
				?.filter(f => !f.isHidden)
				.map(f => {
					if (!f.label) return null;

					return (
						<div key={f.id} className={css(styleSheet.formControlFullWidth)} data-testid='custom-form-field'>
							<label htmlFor={f.id} className={css(styleSheet.label)}>
								{f.label}
								{!f.isOptional ? (
									<>
										{' '}
										<span className={css(baseStyleSheet.required)} data-testid='required-indicator'>
											*
										</span>
									</>
								) : null}
							</label>
							{f.fieldType === FormFieldType.String ? (
								<TextInput
									type='text'
									inputId={f.id}
									inputClassName={css(styleSheet.textInput)}
									disabled
									placeholder='PREVIEW ONLY'
									data-testid='custom-field-input'
								/>
							) : null}
							{f.fieldType === FormFieldType.Option ? getFieldOptions(f) : null}
							{f.fieldType === FormFieldType.MultipleOptions ? getMultipleOptions(f) : null}
						</div>
					);
				})}
		</div>
	);
};
